import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";
import {
  getSubUserDefaultRoute,
  getSubUserPagePermissions,
  isRouteAllowedForSubUser,
  isSubUser,
} from "../utils/subUser";

const ProtectedRoute = ({ element, user, setData, session, setSessionData }) => {
  const location = useLocation();

  if (!isAuthenticated(user)) {
    return <Navigate to="/sign-in" replace />;
  }

  if (isSubUser(user)) {
    const permissions = getSubUserPagePermissions(user);
    if (!isRouteAllowedForSubUser(location.pathname, permissions)) {
      return <Navigate to={getSubUserDefaultRoute(permissions)} replace />;
    }
  }

  return React.cloneElement(element, {
    userData: user,
    setData: setData,
    setSessionData: setSessionData,
    session: session,
  });
};

export default ProtectedRoute;
